import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
 import { useStaticQuery, graphql, withPrefix } from "gatsby"

const IndexPage = () => {
  const content = useStaticQuery(graphql`
    {
      homepage: markdownRemark(frontmatter: {path: {eq: "/"}}) {
        html
      }
    image: markdownRemark(frontmatter: {path: {eq: "/gallery"}, homepage: {eq: true}}) {
  frontmatter {
    title
    image
    medium
    dimensions
  }
}
imageFile: file(relativePath: {eq: "gallery/xenia/xenia.jpg"}) {
  publicURL
}
            
          
     
    }
  `)

  return (
    <Layout>
      <SEO title="Home" />

      <section className='homepage'>
        <div className='layout container'>
          <div className='image'>
            <figure>
              <div className='frame'>
           <img src="/website/static/xenia-ae1f55316874d67f5c34e0027e70f9b5.jpg" alt={content.image.frontmatter.title} />
              </div>

              <figcaption>
                <dl>
                  <dt>{content.image.frontmatter.title}</dt>
                  <dd>{content.image.frontmatter.medium}</dd>
                  <dd>{content.image.frontmatter.dimensions}</dd>
                </dl>
              </figcaption>
            </figure>
          </div>
          
          <div className='intro'>
            <div dangerouslySetInnerHTML={{ __html: content.homepage.html }} />

            <hr className='ornament ornament--small' />
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default IndexPage
